// slices/availabilityConfigApiSlice.js
import { apiSlice } from './apiSlice';

export const availabilityConfigApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get the per-day-of-week availability-type configuration. Any
    // authenticated user can read this — staff need it to know which
    // shift types they're allowed to log on a given day, and the admin
    // config screen uses the same query to load the current settings.
    getAvailabilityConfig: builder.query({
      query: () => '/api/availability-config',
      providesTags: ['AvailabilityConfig'],
    }),

    // Update the configuration. Admin only (enforced server-side).
    updateAvailabilityConfig: builder.mutation({
      query: (data) => ({
        url: '/api/availability-config',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['AvailabilityConfig'],
    }),
  }),
});

export const {
  useGetAvailabilityConfigQuery,
  useUpdateAvailabilityConfigMutation,
} = availabilityConfigApiSlice;